module.exports = __webpack_public_path__ + "static/media/tf.be7b800b.png";